import React from 'react';

/**
 * Call status template
 */
export const StatusTemplate: React.FC<{ isAnswered: boolean }> = ({ isAnswered }) => {
  return (
    <div
      style={{
        padding: '8px 4px',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          display: 'inline-block',
          padding: '4px 8px',
          borderRadius: '12px',
          fontSize: '0.75rem',
          fontWeight: 600,
          backgroundColor: isAnswered ? '#f0fdf4' : '#fef2f2',
          color: isAnswered ? '#16a34a' : '#dc2626',
          border: `1px solid ${isAnswered ? '#bbf7d0' : '#fecaca'}`,
          whiteSpace: 'nowrap',
        }}
      >
        {isAnswered ? 'Answered' : 'No Answer'}
      </div>
    </div>
  );
};

export default StatusTemplate;
